export default "__VITE_ASSET__b3ba14f5__"